import { useRouter } from "next/router";
import React, {
  FunctionComponent,
  ReactNode,
  useEffect,
  useState,
} from "react";
import { useAuth } from "../../../store/useAuth";
import useCookies from "hooks/useCookies";
import { useCurrentStep } from "store/useSteps";

interface Props {
  children: ReactNode;
  roleId?: number;
}

const ProtectedPage: FunctionComponent<Props> = ({ children, roleId }) => {
  const router = useRouter();
  const { get } = useCookies();
  const [loading, setLoading] = useState(true);
  const [redirecting, setRedirecting] = useState(false);
  const { setLogout } = useAuth();
  const { resetStep } = useCurrentStep();

  useEffect(() => {
    const tokenFromCookie = get("accessToken");
    if (roleId) {
      setRedirecting(true);
      window.location.replace("/login");
      return;
    }
    if (!tokenFromCookie) {
      setRedirecting(true);
      setLogout();
      window.location.replace("/login");
      return;
    }
    setLoading(false);
    resetStep();
  }, [roleId, resetStep, setLogout]);

  if (loading || redirecting) {
    return <div />;
  }

  return <div>{children}</div>;
};

export default ProtectedPage;
